// Generated by purs version 0.13.8
"use strict";
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Default = require("../Data.Default/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Generic_Rep_Show = require("../Data.Generic.Rep.Show/index.js");
var Data_Lens_Record = require("../Data.Lens.Record/index.js");
var Data_Lens_Setter = require("../Data.Lens.Setter/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Profunctor_Strong = require("../Data.Profunctor.Strong/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Lunarbox_Data_Editor_Node = require("../Lunarbox.Data.Editor.Node/index.js");
var Lunarbox_Data_Lens = require("../Lunarbox.Data.Lens/index.js");
var FunctionData = function (x) {
    return x;
};
var newtypeFunctionData = new Data_Newtype.Newtype(function (n) {
    return n;
}, FunctionData);
var genericFunctionData = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showFunctionData = new Data_Show.Show(Data_Generic_Rep_Show.genericShow(genericFunctionData)(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "external";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "inputs";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "output";
}))(Data_Show.showRecordFieldsNil)(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "description";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "name";
}))(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showString))))(Data_Show.showArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "description";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "name";
}))(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showString)))))(Data_Show.showBoolean))))(new Data_Symbol.IsSymbol(function () {
    return "FunctionData";
}))));
var encodeJsonFunctionData = Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "name";
}))())(new Data_Symbol.IsSymbol(function () {
    return "description";
}))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "name";
}))())(new Data_Symbol.IsSymbol(function () {
    return "description";
}))())())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "output";
}))())(new Data_Symbol.IsSymbol(function () {
    return "inputs";
}))())(new Data_Symbol.IsSymbol(function () {
    return "external";
}))())();
var displayPinDoc = function (v) {
    return "Name: " + (v.name + ("\x0aDescription: " + v.description));
};
var defaultFunctionData = new Data_Default.Default({
    external: false,
    inputs: Data_Monoid.mempty(Data_Monoid.monoidArray),
    output: {
        name: "output",
        description: "the return value of a function"
    }
});
var decodeJsonFunctionData = Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonBoolean)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "name";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "description";
}))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "name";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "description";
}))()())())(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "output";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "inputs";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "external";
}))()())();
var _PinName = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _PinDescription = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "description";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _FunctionDataOutput = function (dictStrong) {
    var $21 = Lunarbox_Data_Lens.newtypeIso(newtypeFunctionData)(dictStrong);
    var $22 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "output";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($23) {
        return $21($22($23));
    };
};
var _FunctionDataInputs = function (dictStrong) {
    var $24 = Lunarbox_Data_Lens.newtypeIso(newtypeFunctionData)(dictStrong);
    var $25 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "inputs";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($26) {
        return $24($25($26));
    };
};
var internal = function (inputs) {
    return function (output) {
        return Data_Lens_Setter.set(_FunctionDataOutput(Data_Profunctor_Strong.strongFn))(output)(Data_Lens_Setter.set(_FunctionDataInputs(Data_Profunctor_Strong.strongFn))(inputs)(Data_Default.def(defaultFunctionData)));
    };
};
var outputData = internal([ {
    name: "return value",
    description: "The return value of a function"
} ])({
    name: "This node doesn't have an output",
    description: ""
});
var getFunctionData = function (getter) {
    return function (v) {
        if (v instanceof Lunarbox_Data_Editor_Node.ComplexNode) {
            return getter(v["value0"]["function"]);
        };
        if (v instanceof Lunarbox_Data_Editor_Node.OutputNode) {
            return outputData;
        };
        if (v instanceof Lunarbox_Data_Editor_Node.InputNode) {
            return Data_Default.def(defaultFunctionData);
        };
        throw new Error("Failed pattern match at Lunarbox.Data.Editor.FunctionData (line 69, column 26 - line 73, column 19): " + [ v.constructor.name ]);
    };
};
var _FunctionDataExternal = function (dictStrong) {
    var $27 = Lunarbox_Data_Lens.newtypeIso(newtypeFunctionData)(dictStrong);
    var $28 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "external";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($29) {
        return $27($28($29));
    };
};
module.exports = {
    FunctionData: FunctionData,
    getFunctionData: getFunctionData,
    internal: internal,
    outputData: outputData,
    displayPinDoc: displayPinDoc,
    "_FunctionDataInputs": _FunctionDataInputs,
    "_FunctionDataOutput": _FunctionDataOutput,
    "_FunctionDataExternal": _FunctionDataExternal,
    "_PinName": _PinName,
    "_PinDescription": _PinDescription,
    genericFunctionData: genericFunctionData,
    newtypeFunctionData: newtypeFunctionData,
    encodeJsonFunctionData: encodeJsonFunctionData,
    decodeJsonFunctionData: decodeJsonFunctionData,
    showFunctionData: showFunctionData,
    defaultFunctionData: defaultFunctionData
};
